import { css } from '@emotion/css';
import { Flex, theme } from 'antd';
import type React from 'react';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router';
import { useGetMyLabIdentifiers } from '../../api/my-context.queries.ts';
import { useLabResultViewStore } from '../../store/useLabResultViewStore.ts';
import { BefundView } from './details/BefundView.tsx';
import { BefundeList } from './list/BefundeList.tsx';

const useBefundeClassNames = () => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      layout: css`
        height: 100%;
        max-width: 100vw;
        overflow: hidden;
        padding: ${token.paddingLG}px ${token.paddingLG}px 0 ${token.paddingLG}px;
        position: relative; /* important for absolute details list on mobile */

        @media (max-width: ${token.screenLG}px) {
          padding-top: 0;
        }
      `,
    }),
    [token]
  );
};

export const Befunde: React.FC = () => {
  const { id } = useParams();
  const { layout } = useBefundeClassNames();
  const { data, error } = useGetMyLabIdentifiers();
  const setSelectedId = useLabResultViewStore(state => state.setSelectedId);

  useEffect(() => {
    setSelectedId(id);
  }, [setSelectedId, id]);

  useEffect(() => {
    if (error) {
      console.error('error loading my lab identifiers', error);
    }
  }, [error]);

  return (
    <Flex className={layout}>
      <BefundeList myLabIdentifiers={data} />
      <BefundView myLabIdentifiers={data} deemphasizePathological={false} />
    </Flex>
  );
};
